import React, {Component} from 'react';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import 'rc-time-picker/assets/index.css';

const now = moment().hour(0).minute(0);

const TIME_FORMAT = 'h:mm a';

type Props = {
  message: string;
  time: ?string;
  onRequestChangeTime: (time: string) => void;
}

export default class TimeField extends Component {
  props: Props;
  dateRef: ?TimePicker;

  onChange = (value) => {
    this.props.onRequestChangeTime(value);
  }

  render() {
    return (
      <TimePicker
        showSecond={false}
        defaultValue={now}
        value={moment.utc(this.props.time)}
        className="xxx"
        onChange={this.onChange}
        format={TIME_FORMAT}
        use12Hours
        inputReadOnly
      />
    );
  }


}



// WEBPACK FOOTER //
// ./src/components/forms/TimeInput.js